import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import TopBar from './components/TopBar';
import DashboardView from './views/DashboardView';
import TimelineView from './views/TimelineView';
import PlacesView from './views/PlacesView';
import BudgetView from './views/BudgetView';
import PackingView from './views/PackingView';
import DemoView from './views/DemoView';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard': return <DashboardView key="dashboard" />;
      case 'demo': return <DemoView key="demo" />;
      case 'timeline': return <TimelineView key="timeline" />;
      case 'places': return <PlacesView key="places" />;
      case 'budget': return <BudgetView key="budget" />;
      case 'packing': return <PackingView key="packing" />;
      default: return <DashboardView key="dashboard" />;
    }
  };

  return (
    <div className="min-h-screen bg-midnight-900 text-gray-100 flex selection:bg-cyan-400/30 overflow-x-hidden">
      <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <main className="flex-1 md:ml-64 flex flex-col min-h-screen relative overflow-hidden">
        {/* Background Ambient Effects */}
        <div className="fixed top-0 left-1/4 w-[500px] h-[500px] bg-cyan-500/5 rounded-full blur-[140px] pointer-events-none"></div>
        <div className="fixed bottom-0 right-1/4 w-[500px] h-[500px] bg-coral-500/5 rounded-full blur-[140px] pointer-events-none"></div>

        <TopBar />
        
        <div className="flex-1 p-6 md:p-8 lg:p-12 overflow-y-auto pb-32 md:pb-12 relative z-10 scrollbar-hide">
          <AnimatePresence mode="wait">
            {renderContent()}
          </AnimatePresence>
        </div>
      </main>
    </div>
  );
}

export default App;